import styled from "styled-components";

export const StyledApp = styled.div``;
